import { CompanyDto } from './company-dto.model';
import { EmployeeDto } from './employee-dto.model';
import { EmployeeTrainingDto } from './employee-training-dto.model';


export class AttendeesDto implements IAttendeesDto {
    id!: number;
    companyId!: number;
    company!: CompanyDto;
    employeeId!: number;
    employee!: EmployeeDto;
    employeeTrainingId!: number | undefined;
    employeeTraining!: EmployeeTrainingDto;
    isAccepted!: boolean;

    constructor(data?: IAttendeesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.employeeId = _data["employeeId"];
            this.employee = _data["employee"] ? EmployeeDto.fromJS(_data["employee"]) : <any>undefined;
            this.employeeTrainingId = _data["employeeTrainingId"];
            this.employeeTraining = _data["employeeTraining"] ? EmployeeTrainingDto.fromJS(_data["employeeTraining"]) : <any>undefined;
            this.isAccepted = _data["isAccepted"];
        }
    }

    static fromJS(data: any): AttendeesDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendeesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["employeeId"] = this.employeeId;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["employeeTrainingId"] = this.employeeTrainingId;
        data["employeeTraining"] = this.employeeTraining ? this.employeeTraining.toJSON() : <any>undefined;
        data["isAccepted"] = this.isAccepted;
        return data; 
    }
}

export interface IAttendeesDto {
    id: number;
    companyId: number;
    company: CompanyDto;
    employeeId: number;
    employee: EmployeeDto;
    employeeTrainingId: number | undefined;
    employeeTraining: EmployeeTrainingDto;
    isAccepted: boolean;
}

